import { getReadingTime } from '../utilities'
import { AJAX_URL, LOADING_CLASS, SUPPORT_EMAIL } from '../utilities/constants'

export default class {
  constructor(el, options) {
    const messageEl = el.querySelector('.js-formMessage')
    const submitEl = el.querySelector('.js-formSubmit')

    if (messageEl && messageEl?.textContent?.length) {
      messageEl.removeAttribute('hidden')
      messageEl.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }

    if (options.static) {
      return
    }

    el.addEventListener('submit', async function (e) {
      e.preventDefault()

      try {
        messageEl.setAttribute('hidden', true)
        messageEl.replaceChildren()

        if (submitEl) {
          submitEl.classList.add(LOADING_CLASS)
          submitEl.setAttribute('disabled', true)
        }

        const formData = new FormData(e.currentTarget)

        if (options.action) {
          formData.append('action', options.action)
        }

        e.currentTarget
          .querySelectorAll('input[type=file]')
          .forEach((fileInputElement) => {
            if (fileInputElement.files.length) {
              formData.append(
                fileInputElement.getAttribute('name'),
                fileInputElement.files[0],
              )
            }
          })

        const response = await fetch(AJAX_URL, {
          body: formData,
          method: 'POST',
          mode: 'same-origin',
        })

        if (options.debug) {
          console.info({ response })
        }

        const json = await response.json()
        const data = json?.data || json

        if (options.debug) {
          console.info({ data })
        }

        if (data.message) {
          messageEl.removeAttribute('hidden')

          if (Array.isArray(data.message)) {
            messageEl.innerHTML = data.message.join('<br>')
          } else {
            messageEl.innerHTML = data.message
          }

          messageEl.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          })
        }

        if (response.ok && (data.redirect_to || data.reload)) {
          setTimeout(
            () => {
              if (data.reload) {
                window.location.reload()
              } else if (data.redirect_to) {
                window.location.href = data.redirect_to
              }
            },
            data.message ? Math.max(1000, getReadingTime(data.message)) : 0,
          )
        }
      } catch (e) {
        console.error(e)

        messageEl.removeAttribute('hidden')
        messageEl.innerHTML = `${e.toString()} (Något gick fel, försök igen eller kontakta oss på ${SUPPORT_EMAIL})`
        messageEl.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        })
      } finally {
        submitEl.classList.remove(LOADING_CLASS)
        submitEl.removeAttribute('disabled')
      }

      return false
    })
  }
}
